import { render, staticRenderFns } from "./IncomeStatistics3.vue?vue&type=template&id=0623ad97&scoped=true&"
import script from "./IncomeStatistics3.vue?vue&type=script&lang=js&"
export * from "./IncomeStatistics3.vue?vue&type=script&lang=js&"
import style0 from "./IncomeStatistics3.vue?vue&type=style&index=0&id=0623ad97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0623ad97",
  null
  
)

export default component.exports